import { Filter } from '@cubejs-client/core';

import { SpendType } from '~/common/types/cubes/SpendType';
import { useModuleContext } from '~/components/ModuleContextProvider';

import { CUBE, AverageNegotiationSavingsWidget } from './AverageNegotiationSavingsWidget';

interface SupplierAverageNegotiationSavingsWidgetProps {
  spendType: SpendType;
}
export const SupplierAverageNegotiationSavingsWidget = ({
  spendType,
}: SupplierAverageNegotiationSavingsWidgetProps) => {
  const { entityId } = useModuleContext();

  const filters: Filter[] = [
    {
      member: `${CUBE}.supplier_id`,
      operator: 'equals',
      values: [entityId],
    },
  ];

  return <AverageNegotiationSavingsWidget filters={filters} spendType={spendType} />;
};
